import { useEffect } from 'react';
import { useOrion } from '../context/OrionContext';
import { copiarTexto } from '../services/plataforma';

// ─────────────────────────────────────────────────────────────────────────────
// Atalhos de teclado da aplicação.
//
// São os do 1.4.1, e existem por um motivo prático: durante o atendimento o
// operador está com o telefone numa mão. Ctrl+E manda o ticket formatado para a
// área de transferência sem tirar o olho da conversa.
//
//   Ctrl+E         copia o ticket formalizado
//   Ctrl+Q         copia a mensagem de conclusão configurada
//   Ctrl+Shift+T   abre e fecha as Configurações
//
// Não renderiza nada — é só o ouvinte. Fica montado no shell.
//
// Os atalhos NÃO disparam enquanto se digita num campo, com uma exceção:
// Ctrl+E e Ctrl+Q, que são justamente para usar com o campo em foco.
// ─────────────────────────────────────────────────────────────────────────────

/** O foco está num campo de texto? */
function digitando(alvo) {
  if (!alvo) return false;
  const tag = alvo.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || alvo.isContentEditable;
}

export default function AtalhosGlobais({ textoDoTicket = '' }) {
  const { mensagemConclusao, view, setView, avisar } = useOrion();

  useEffect(() => {
    const aoTeclar = async (e) => {
      if (!e.ctrlKey && !e.metaKey) return;
      const tecla = String(e.key || '').toLowerCase();

      // Ctrl+Shift+T — Configurações. Não dispara no meio de uma digitação.
      if (e.shiftKey && tecla === 't') {
        if (digitando(e.target)) return;
        e.preventDefault();
        setView(view === 'configuracoes' ? 'helpdesk' : 'configuracoes');
        return;
      }

      if (e.shiftKey) return;

      // Ctrl+E — o ticket formalizado. Ctrl+Q — a mensagem de conclusão.
      const copias = {
        e: { texto: textoDoTicket, rotulo: 'Ticket copiado.' },
        q: { texto: mensagemConclusao, rotulo: 'Mensagem de conclusão copiada.' },
      };
      const alvo = copias[tecla];
      if (!alvo || !String(alvo.texto || '').trim()) return;  // nada a copiar

      e.preventDefault();
      // try/catch porque a área de transferência REJEITA fora de contexto
      // seguro: sem isto o atalho falhava calado, sem aviso nenhum.
      let copiou = false;
      try { copiou = await copiarTexto(alvo.texto); } catch (err) { copiou = false; }
      avisar(copiou ? alvo.rotulo : 'Não foi possível copiar.',
        { tipo: copiou ? 'ok' : 'erro' });
    };

    window.addEventListener('keydown', aoTeclar);
    return () => window.removeEventListener('keydown', aoTeclar);
  }, [textoDoTicket, mensagemConclusao, view, setView, avisar]);

  return null;
}
